import API from "./API";

const thumbnailBlobUrlCache = new Map();
const thumbnailRequestCache = new Map();

const getPresignedThumbnailUrl = async (id) => {
  const response = await API.get(`thumbnails/${id}`);
  return typeof response?.data?.url === "string" ? response.data.url.trim() : "";
};

const cacheThumbnailAsset = async (id, sourceUrl) => {
  if (!sourceUrl) {
    return "";
  }

  if (typeof fetch !== "function" || typeof URL?.createObjectURL !== "function") {
    return sourceUrl;
  }

  try {
    const assetResponse = await fetch(sourceUrl, { credentials: "omit" });
    if (!assetResponse.ok) {
      throw new Error(`Thumbnail asset request failed with status ${assetResponse.status}`);
    }

    const thumbnailBlob = await assetResponse.blob();
    const blobUrl = URL.createObjectURL(thumbnailBlob);
    thumbnailBlobUrlCache.set(id, blobUrl);
    return blobUrl;
  } catch (error) {
    console.warn(
      `Unable to cache thumbnail asset for ${id}; using presigned URL fallback.`,
      error
    );
    return sourceUrl;
  }
};

export const getItem = (contentType, itemId, json) => {
  return API.get(`${contentType}/${itemId}`, { requiresAuth: true }).then((response) => response.data);
};

export const getThumbnail = async (id) => {
  if (!id) return "";

  if (thumbnailBlobUrlCache.has(id)) {
    return thumbnailBlobUrlCache.get(id);
  }

  if (thumbnailRequestCache.has(id)) {
    return thumbnailRequestCache.get(id);
  }

  const thumbnailRequest = (async () => {
    try {
      const presignedUrl = await getPresignedThumbnailUrl(id);
      return await cacheThumbnailAsset(id, presignedUrl);
    } catch (error) {
      console.error(`Error fetching thumbnail for ${id}:`, error);
      return "";
    } finally {
      thumbnailRequestCache.delete(id);
    }
  })();

  thumbnailRequestCache.set(id, thumbnailRequest);
  return thumbnailRequest;
};

export const clearThumbnailCache = () => {
  thumbnailBlobUrlCache.forEach((blobUrl) => {
    URL.revokeObjectURL(blobUrl);
  });
  thumbnailBlobUrlCache.clear();
  thumbnailRequestCache.clear();
};
